module.exports = __webpack_public_path__ + "img/ghdlogo.b2112995.svg";